<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <!-- NOTE: リスト画面に戻るボタン -->
        <common-detail-back-button class="mb-3" @onBackPage="backPage" :button-title-props="headerText" />
        <!-- コンテンツ領域 -->
        <b-row class="p-0 m-0">
          <b-col cols="12" class="p-0 m-0">
          </b-col>
          <b-col cols="12" class="w-100 p-0">
            <b-card>
              <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(clickSave)">
                  <b-row class="p-0 m-0 mb-1" style="border-bottom: solid 1px rgba(0, 0, 0, 0.1);">
                    <b-col cols="12" class="w-100 p-0">
                      <b-row class="p-0 m-0 align-content-center justify-content-between">
                        <b-col cols="4" class="w-100 p-0">
                          <CommonSelectAction :options="computedOptionAction" />
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="12" class="w-100 mt-3 p-0 m-0">
                      <b-row class="p-0 m-0">
                        <b-col cols="3" class="m-0 p-0">
                          <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 mr-2 text-black m-0 pb-1">更新日時：<span class="m-0">{{ invoiceList.updated_timestamp }}</span></b-form-text>
                        </b-col>
                        <b-col cols="3" class="m-0 p-0">
                          <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 ml-2 mr-2 text-black m-0 pb-1">作成日時：<span class="m-0">{{ invoiceList.registered_timestamp }}</span></b-form-text>
                        </b-col>
                        <b-col cols="3" class="m-0 p-0">
                            <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 ml-2 mr-2 text-black m-0 pb-1">最終更新者：<span class="m-0">{{ lastUpdateUserName }}</span></b-form-text>
                        </b-col>
                        <b-col cols="3" class="m-0 p-0">
                            <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 ml-2 text-black m-0 pb-1">請求書番号：<span class="m-0">{{ invoiceNumber }}</span></b-form-text>
                        </b-col>
                      </b-row>
                      <b-row class="p-0 m-0 mt-3">
                        <b-col cols="6" class="m-0 p-0">
                          <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 mr-2 text-black m-0 pb-1">売上計上年月：<span class="m-0">{{ earmarkingYearMonth }}</span></b-form-text>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="12" class="w-100 mt-3 p-0">
                      <b-row class="p-0 m-0">
                        <b-col cols="12" class="p-0 m-0">
                          <h2 class="fs-18-bold mb-2">請求先情報</h2>
                        </b-col>
                      </b-row>
                        <b-row class="p-0 m-0 mt-1">
                          <b-col cols="3" class="p-0 m-0">
                            <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先名</b-form-text>
                            <p class="fs-14-regular m-0 mt-1 height-box">{{ invoiceList.bill_to_corporate_name }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0">
                            <div class="border-bottom-secondary-dashed-1 ml-2 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先名（カナ）</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_corporate_name_kana }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0">
                            <div class="border-bottom-secondary-dashed-1 ml-2 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先郵使番号</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_postcode }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0">
                            <div class="border-bottom-secondary-dashed-1 ml-2 h-100">
                              <b-form-text class="fs-12-bold text-black">請求先都道府県</b-form-text>
                              <p class="fs-14-regular m-0 height-box">{{ prefectureName }}</p>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="p-0 m-0">
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                              <b-form-text class="fs-12-bold text-black">部門名</b-form-text>
                              <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_corporate_division_name }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                            <b-form-text class="fs-12-bold text-black">敬称</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ honorificMaster }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 ml-2 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先市区町村</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address_city }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 ml-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先市区町村（カナ）</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address_city_kana }}</p>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="p-0 m-0">
                          <b-col cols="3" class="p-0 m-0 mt-3">
                              <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                                  <b-form-text class="fs-12-bold text-black">請求先担当者名</b-form-text>
                                  <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_staff_name }}</p>
                              </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                              <div class="border-bottom-secondary-dashed-1 mr-1 ml-2 h-100">
                                  <b-form-text class="fs-12-bold text-black">請求先担当者名（カナ）</b-form-text>
                                  <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_staff_name_kana }}</p>
                              </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 ml-2 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先番地</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 ml-2 h-100">
                            <b-form-text class="fs-12-bold text-black">請求先番地（カナ）</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address_kana }}</p>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="p-0 m-0">
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                            <b-form-text class="fs-12-bold text-black">諸求先建物名など</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address_additional }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                            <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                            <b-form-text class="fs-12-bold text-black">諸求先建物名など（カナ）</b-form-text>
                            <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_address_additional_kana }}</p>
                            </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                              <div class="border-bottom-secondary-dashed-1 ml-2 mr-2 h-100">
                                  <b-form-text class="fs-12-bold text-black">請求先電話番号</b-form-text>
                                  <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_telephone_number }}</p>
                              </div>
                          </b-col>
                          <b-col cols="3" class="p-0 m-0 mt-3">
                              <div class="border-bottom-secondary-dashed-1 ml-2 h-100">
                                  <b-form-text class="fs-12-bold text-black">請求先FAX番号</b-form-text>
                                  <p class="fs-14-regular m-0 height-box">{{ invoiceList.bill_to_fax_number }}</p>
                              </div>
                          </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" class="m-0 p-0 mt-1">
                      <div class="border-bottom-secondary-1 my-3"></div>
                    </b-col>
                    <b-col cols="12" class="w-100 p-0 m-0">
                      <b-row class="p-0 m-0">
                        <b-col cols="12" class="p-0 m-0">
                          <h2 class="fs-16-bold mb-2">支払い方法</h2>
                        </b-col>
                      </b-row>
                        <b-row class="p-0 m-0 mt-1">
                          <b-col cols="6" class="m-0 p-0">
                            <b-form-text class="fs-14-regular border-bottom-secondary-dashed-1 mr-2 text-black pb-1">入金種別：<span class="m-0">{{ paymentMethod }}</span></b-form-text>
                          </b-col>
                          <b-col cols="6" class="m-0 p-0">
                            <b-form-text v-if="invoiceList.payment_method === 2" class="fs-14-regular border-bottom-secondary-dashed-1 ml-2 text-black pb-1">名義種別：<span class="m-0">{{ invoiceList.payment_method === 2 ? creditCardTypeName : '' }}</span></b-form-text>
                          </b-col>
                        </b-row>
                        <b-row class="p-0 m-0 mt-2">
                          <b-col cols="12" class="m-0 p-0">
                            <h2 class="fs-16-bold mt-2">口座情報</h2>
                          </b-col>
                          <b-col cols="12" class="m-0 p-0">
                              <b-row class="m-0 p-0">
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">銀行コード：<span class="m-0">{{ invoiceList.payment_bank_code }}</span></b-form-text>
                                  </div>
                                </b-col>
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">支店コード：<span class="m-0">{{ invoiceList.payment_bank_branch_code }}</span></b-form-text>
                                  </div>
                                </b-col>
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">銀行名：<span class="m-0">{{ invoiceList.payment_bank_name }}</span></b-form-text>
                                  </div>
                                </b-col>
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 ml-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">支店名：<span class="m-0">{{ invoiceList.payment_bank_branch_name }}</span></b-form-text>
                                  </div>
                                </b-col>
                              </b-row>
                              <b-row class="m-0 p-0 mt-3 pb-1">
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">口座番号：<span class="m-0">{{ invoiceList.payment_bank_account_number }}</span></b-form-text>
                                  </div>
                                </b-col>
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">口座名義：<span class="m-0">{{ invoiceList.payment_bank_account_name }}</span></b-form-text>
                                  </div>
                                </b-col>
                                <b-col cols="3" class="m-0 p-0">
                                  <div class="border-bottom-secondary-dashed-1 mr-2 ml-2 h-100">
                                    <b-form-text class="fs-14-regular text-black">預金種別：<span class="m-0">{{ invoiceList.payment_bank_deposit_type === 1 ? '普通' : '当座' }}</span></b-form-text>
                                  </div>
                                </b-col>
                              </b-row>
                            <p class="mt-3 fs-14-regular">※ 変更の必要がある場合は、顧客情報から行なってください。</p>
                          </b-col>
                        </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="p-0 m-0 mt-3">
                    <h3 class="w-100 m-0 fs-18-bold">請求項目</h3>
                    <b-col cols="12" class="p-0 m-0 mt-3">
                      <CommonTable
                        :tableItemsProps="costItems"
                        :fieldsProps="costFields"
                        :stickyHeaderProps="true"
                        class="fs-12-regular"
                      />
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-card>
          </b-col>
        </b-row>
      </main>
      <!-- 請求書の作成 -->
      <b-modal centered content-class="customBtnClose"  id="modal-invoice-create">
        <template #modal-header="{ close }">
          <b-button variant="outline-danger" @click="close()" class="p-0">
            <span>閉じる</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path id="Icon_ionic-ios-close-circle" data-name="Icon ionic-ios-close-circle" d="M11.375,3.375a8,8,0,1,0,8,8A8,8,0,0,0,11.375,3.375Zm2.027,10.9-2.027-2.027L9.348,14.271a.615.615,0,1,1-.869-.869l2.027-2.027L8.479,9.348a.615.615,0,0,1,.869-.869l2.027,2.027L13.4,8.479a.615.615,0,0,1,.869.869l-2.027,2.027L14.271,13.4a.618.618,0,0,1,0,.869A.611.611,0,0,1,13.4,14.271Z" transform="translate(-3.375 -3.375)" fill="#fff"/>
            </svg>
          </b-button>
        </template>
        <p class="m-0">請求書を作成済にします。<br>よろしいですか？</p>
        <template v-slot:modal-footer="{ok, cancel}">
          <b-row class="w-100 m-auto align-content-center justify-content-between">
            <b-col cols="12" class="d-flex justify-content-center">
              <b-button pill class="w-100 fs-14-bold text-black bg-white border-secondary mr-2" style="max-width: 150px;" variant="secondary" @click="cancel">キャンセル</b-button>
              <b-button pill class="w-100 text-white fs-14-bold" style="max-width: 150px;" variant="primary" @click="ok, confirmed()">作成済にする</b-button>
            </b-col>
          </b-row>
        </template>
      </b-modal>
      <!-- 請求書PDFの文言編集 -->
      <b-modal centered id="modal-invoice-word-editing" title="請求書下部に表示する文言を入力してください。" :hide-footer="true" ref="editModal" content-class="customBtnClose">
        <template #modal-header="{ close }">
          <CommonModalButtonClose @closeModal="close()"/>
        </template>
        <p class="fs-16-bold pb-3 mb-3 border-bottom">請求書下部に表示する文言を入力してください。</p>
        <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
          <b-form @submit.stop.prevent="handleSubmit(invoiceWordEditing)">
            <div class="w-100 mb-3">
              <validation-provider class="w-100" name="請求書下部の文言" :rules="{ max: 100 }" v-slot="validationContext">
                <b-textarea
                  v-model="invoicePdfChangeText"
                  rows="3"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                />
                <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </div>
            <b-row class="w-100 m-auto align-content-center justify-content-between">
              <b-col cols="12" class="d-flex justify-content-center">
                <b-button class="fs-14-bold text-black mr-2" pill variant="outline-secondary" @click="closeWordEditingModal()">キャンセル</b-button>
                <b-button class="fs-14-bold text-white" pill variant="primary" type="submit">変更する</b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- ローディング -->
      <b-modal centered :title="isModalText" v-model="showLoading" hide-header hide-footer hide-header-close no-close-on-backdrop no-close-on-esc>
        <div class="text-center">
          <CommonLoader :title="isModalText" />
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>

// Vuex
import { mapActions } from 'vuex'
import { SET_SEARCH_ITEM, SET_SELECT_ITEM, SET_SELECT_ALL_FLAG, SET_SCROLL_POSITION } from '../../../modules/common/mutation-types'

// NOTE: 共通テーブルUI
import CommonTable from '../../../components/common/CommonTable'

// NOTE: ローディングの共通文言を取得
import LoadingTxt from '../../../utils/loading-text-util'

// NOTE: 詳細画面戻る用のUI
import CommonDetailBackButton from '../../../components/common/CommonDetailBackButton'

// NOTE: トーストの共通文言を取得
import ToastTextUtil from '../../../utils/toast-text-util'
import CommonModalButtonClose from '@/components/common/CommonModalButtonClose.vue'
import CommonSelectAction from '@/components/common/CommonSelectAction.vue'
import CommonLoader from '@/components/common/CommonLoader'

export default {
  components: {
    CommonModalButtonClose,
    CommonDetailBackButton,
    CommonTable,
    CommonSelectAction,
    CommonLoader
  },
  data () {
    return {
      invoiceNumber: '',
      lastUpdateUserName: '',
      costItems: [],
      costFields: [
        {
          key: '項目',
          label: '項目',
          class: 'text-left'
        },
        {
          key: '勘定科目',
          label: '勘定科目',
          class: 'text-left'
        },
        {
          key: '計上年月',
          label: '計上年月',
          class: 'text-center'
        },
        {
          key: '期間',
          label: '期間',
          class: 'text-center'
        },
        {
          key: '数量',
          label: '数量',
          class: 'text-center'
        },
        {
          key: '単価',
          label: '単価',
          class: 'text-right'
        },
        {
          key: '金額',
          label: '金額',
          class: 'text-right'
        },
        {
          key: '備考',
          label: '備考',
          class: 'text-center'
        }
      ],
      invoiceList: [], // 請求書
      prefectureName: '', // 請求先都道府県名
      honorificMaster: '', // 敬称
      showLoading: false,
      isModalText: '',
      invoiceStatus: false,
      creditCardTypeName: '',
      invoiceItemList: [],
      invoiceChargeFeeItemItemList: [],
      report: null,
      amountBilled: 0,
      amountBilledTax: 0,
      amountBilledTotal: 0,
      invoiceMadeYearMonth: '',
      businessReportAndInvoiceId: null,
      listPageReturnFlag: false,
      customerId: '',
      invoicePdfChangeText: '',
      paymentMethod: null,
      corporateName: '',
      earmarkingYearMonth: ''
    }
  },
  computed: {
    headerText () {
      // const formatDate = new Date(this.invoiceMadeYearMonth)
      const formatDate = new Date(this.earmarkingYearMonth)
      // 月は-1で出力されるので修正する
      formatDate.setMonth(formatDate.getMonth())
      const monthText = !this.earmarkingYearMonth ? '' : `${formatDate.getFullYear()}年${formatDate.getMonth() + 1}月度`
      // return `${this.corporateName ? this.corporateName : ''}様 請求書${!this.invoiceMadeYearMonth ? '' : new Date(this.invoiceMadeYearMonth).getMonth() + 2}月度`
      return `${this.corporateName ? this.corporateName : ''}様 請求書${monthText}`
    },
    computedOptionAction () {
      return [
        {
          value: 0,
          text: '選択してください',
          event: null,
          disabled: true
        },
        {
          value: 1,
          text: 'プレビュー',
          event: () => this.download(),
          disabled: false
        },
        {
          value: 2,
          text: '請求書の文言を編集する',
          event: () => this.$bvModal.show('modal-invoice-word-editing'),
          disabled: !(this.invoiceStatus === 1 || this.invoiceStatus === 4)
        },
        {
          value: 3,
          text: '作成済にする',
          event: () => this.$bvModal.show('modal-invoice-create'),
          disabled: this.invoiceStatus !== 1
        }
      ]
    }
  },
  mounted () {
    if (document.querySelector('.col.p-4')) {
      document.querySelector('.col.p-4').scrollTop = 0 // この画面に遷移した際、スクロール位置を最上部にする
    }
    this.invoiceNumber = this.$route.params.id
    // this.isModalText = '取得中'
    this.isModalText = LoadingTxt.getTxt
    this.showLoading = true
    let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/invoice/getDetail'
    this.$axios.get(url, { params: { 'invoice_number': this.invoiceNumber } }).then(response => {
      this.invoiceList = response.data.data.invoice[0]
      this.corporateName = response.data.data.corporate_name
      this.prefectureName = response.data.data.prefectureMasterId
      this.honorificMaster = response.data.data.honorificMaster
      this.lastUpdateUserName = response.data.data.updatedUser
      this.invoiceStatus = response.data.data.invoiceStatus
      this.creditCardTypeName = response.data.data.creditCardAccountTypeName
      this.invoiceItemList = response.data.data.invoiceItem
      this.invoiceChargeFeeItemItemList = response.data.data.invoiceChargeFeeItem
      this.report = response.data.data.paymentCycleType
      this.amountBilled = response.data.data.amountBilled
      this.amountBilledTax = response.data.data.amountBilledTax
      this.amountBilledTotal = response.data.data.amountBilledTotal
      this.invoiceMadeYearMonth = response.data.data.invoiceMadeYearMonth
      this.businessReportAndInvoiceId = response.data.data.businessReportAndInvoiceId
      this.customerId = response.data.data.customerId
      // NOTE: 日付変換
      const d = new Date(response.data.data.earmarkingYearMonth)
      const YYYY = d.getFullYear()
      const MM = ('0' + (d.getMonth() + 1)).slice(-2)
      const earmarkingYearMonthDate = `${YYYY}-${MM}`
      this.earmarkingYearMonth = earmarkingYearMonthDate
      if (this.report !== null) {
        // 年払い対応
        if (this.report.payment_cycle_type === 2) this.costFields.push('消費税対象')
      }
      // 入金種別
      this.paymentMethod = this.invoiceList.payment_method === 1 ? '振込' : this.invoiceList.payment_method === 2
        ? 'クレジット払い' : this.invoiceList.payment_method === 3 ? '口座振替' : this.invoiceList.payment_method === 4
          ? 'クレジットカード（AMEX）' : this.invoiceList.payment_method === 5 ? 'クレジットカード（VISA）' : 'クレジットカード（その他）'
    }).catch(error => {
      this.$bvToast.toast(
        error.message,
        {
          title: ToastTextUtil.errorTitle,
          variant: 'danger',
          noAutoHide: true,
          toaster: 'b-toaster-top-center'
        }
      )
      this.showLoading = false
    }).finally(() => {
      this.showLoading = false
      this.refreshCostItemTotal()
    })
  },
  methods: {
    // map Vuex actions
    ...mapActions('common', [SET_SEARCH_ITEM, SET_SELECT_ITEM, SET_SELECT_ALL_FLAG, SET_SCROLL_POSITION]),

    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },

    // NOTE: 請求書項目の処理
    refreshCostItemTotal () {
      let items = []
      // NOTE: 請求項目表示
      this.invoiceItemList.forEach(item => {
        items.push({
          '項目': item.item_name,
          '勘定科目': item.account_title_code && item.account ? `${item.account_title_code}:${item.account}` : '',
          '計上年月': item.earmarking_year_month,
          '期間': item.period,
          '数量': item.quantity.toLocaleString(),
          '単価': item.unit_price.toLocaleString(),
          '金額': item.amount_billed.toLocaleString(),
          '備考': item.remark === null ? '' : item.remark
        })
      })
      this.invoiceChargeFeeItemItemList.forEach(item => {
        items.push({
          '項目': item.item_name,
          '勘定科目': '--',
          '計上年月': '--',
          '期間': '--',
          '数量': '--',
          '単価': '--',
          '金額': item.amount_billed.toLocaleString(),
          '備考': '--'
        })
      })
      // NOTE: 金額表示（小計、消費税、合計）
      items.push({ '項目': '小計', '勘定科目': '--', '計上年月': '--', '期間': '--', '数量': '--', '単価': '--', '金額': this.amountBilled.toLocaleString(), '備考': '--' })
      items.push({ '項目': '消費税', '勘定科目': '--', '計上年月': '--', '期間': '--', '数量': '--', '単価': '--', '金額': this.amountBilledTax.toLocaleString(), '備考': '--' })
      items.push({ '項目': '合計', '勘定科目': '--', '計上年月': '--', '期間': '--', '数量': '--', '単価': '--', '金額': this.amountBilledTotal.toLocaleString(), '備考': '--' })
      this.costItems = items
    },

    // NOTE: 作成済み処理
    confirmed () {
      const businessReportAndInvoiceId = []
      const customerId = []
      businessReportAndInvoiceId.push(this.businessReportAndInvoiceId)
      customerId.push(this.customerId)
      // this.isModalText = ''
      this.isModalText = LoadingTxt.allProcessingTxt
      this.showLoading = true
      let url = process.env.VUE_APP_BASE_API_URL + '/api/v1/invoice/updateStatus'
      // this.$axios.post(url, { 'invoice_number': this.invoiceNumber, 'status': 2 }).then(response => {
      this.$axios.post(url, { 'business_report_and_invoice_id': businessReportAndInvoiceId, 'status': 2, 'customer_id': customerId }).then(response => {
        // this.listPageReturnFlag = true
        // this.$router.back()
        this.backPage()
      }).catch(error => {
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
        this.showLoading = false
      }).finally(() => {
        this.showLoading = false
      })
    },

    // NOTE: PDFをダウンロード
    download () {
      this.isModalText = LoadingTxt.downloadPdfTxt
      this.showLoading = true
      const url = process.env.VUE_APP_BASE_API_URL + '/api/v1/invoice/pdfDownload'
      this.$axios.get(url, { responseType: 'blob', params: { 'invoice_number': this.invoiceNumber } }).then(response => {
        this.savePdf(response.data, '請求書.pdf')
      }).catch(error => {
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
        this.showLoading = false
      }).finally(() => {
        this.showLoading = false
      })
    },

    // NOTE: 保存処理
    savePdf (pdfData, fileName) {
      const newBlob = new Blob([pdfData], { type: 'application/pdf' })
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }
      const data = window.URL.createObjectURL(newBlob)
      // NOTE: 印刷ダイアログが表示される実装
      // const newWindow = window.open(data, '_blank')
      // newWindow.document.title = fileName
      const link = document.createElement('a')
      link.href = data
      link.download = fileName
      link.click()
      this.$bvToast.toast('ダウンロードしました。', { title: ToastTextUtil.successTitle, variant: 'success', toaster: 'b-toaster-top-center' })
    },

    // NOTE: リスト表示ページに戻る（前のページ）
    backPage () {
      this.listPageReturnFlag = true
      this.$router.go(-1)
    },

    // NOTE: 請求書の文言を編集する
    invoiceWordEditing () {
      this.isModalText = LoadingTxt.changeTxt
      this.showLoading = true
      const url = process.env.VUE_APP_BASE_API_URL + '/api/v1/invoice/invoiceWordEditing'
      this.$axios.post(url, { 'invoice_number': this.invoiceNumber, 'change_text': this.invoicePdfChangeText }).then(response => {
        this.$bvToast.toast('文言を変更しました', { title: ToastTextUtil.successTitle, variant: 'success', toaster: 'b-toaster-top-center' })
        this.$bvModal.hide('modal-invoice-word-editing')
        this.invoicePdfChangeText = ''
      }).catch(error => {
        this.$bvToast.toast(
          error.message,
          {
            title: ToastTextUtil.errorTitle,
            variant: 'danger',
            noAutoHide: true,
            toaster: 'b-toaster-top-center'
          }
        )
        this.showLoading = false
      }).finally(() => {
        this.showLoading = false
      })
    },

    // NOTE: 請求書文言変更モーダルのクローズ処理
    closeWordEditingModal () {
      this.invoicePdfChangeText = ''
      // NOTE: 請求書文言変更モーダルが内包しているonCloseメソッドを発火してモーダルを閉じる
      this.$refs.editModal.onClose()
    }
  },
  // NOTE: SET_SEARCH_ITEMを初期化
  beforeDestroy () {
    if (!this.listPageReturnFlag) {
      this.SET_SEARCH_ITEM(null)
      this.SET_SELECT_ITEM([])
      this.SET_SELECT_ALL_FLAG(false)
      this.SET_SCROLL_POSITION(0)
    }
  }
}

</script>

<style lang="css" scoped>
.select-action {
  max-width: 145px;
}
.height-box {
  min-height: 20px;
}
</style>
<style>
#modal-invoice-create footer {
  padding-top: 0 !important;
}
</style>
